<template>
  <pl-dialog :disableOutsideClick="true" size="confirm_size" title="End Discussion" @close="$emit('close')">
    <div class="flex flex-col h-full py-4 px-6">
      <div class="flex flex-grow h-full mb-5">
        <div class="flex flex-col space-y-2 text-gray-700">
          <span>
            Stopping the discussion <span class="font-medium">will prevent discussion statistics</span> from
            changing, and students <span class="font-medium">will not be able</span> to tap in.
          </span>
          <span>You <span class="font-medium">will be able to restart</span> the discussion whenever you want.</span>
        </div>
      </div>
      <div class="flex items-center justify-between space-x-4">
        <button
          @click="show_confirm_end_discussion = false"
          class="w-full bg-gray-100 border border-solid border-gray-200 rounded-md py-2 px-4 text-gray-700"
        >
          Cancel
        </button>
        <button
          class="flex justify-center items-center space-x-2 w-full bg-red-500 rounded-md border border-solid border-red-500 py-2 px-4 text-white"
          @click="handleEndDiscussion()"
        >
          <span>Stop Discussion</span>
          <div v-if="isEnding" class="loader"></div>
        </button>
      </div>
    </div>
  </pl-dialog>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';

  export default Vue.extend({
    data() {
      return {
       isEnding: false,
      };
    },
    computed: {
      ...mapGetters(['getCurrentDiscussion']),
    },
    methods: {
      handleEndDiscussion: async function() {
        this.isEnding = true;
        if (this.getCurrentDiscussion.audio_discussion_is_enabled) {
          const video = document.querySelector('.local-camera');
          if (video && video.srcObject) {
            let tracks = video.srcObject.getTracks();
            tracks.forEach((track) => track.stop());
          }
          await this.$store.dispatch('endAudioCall', this.getCurrentDiscussion.id);
        }
        await this.$store.dispatch('endLiveDiscussion', this.getCurrentDiscussion.id);
        this.isEnding = false;
        this.$emit('close');
      }
    }
  });
</script>


// WEBPACK FOOTER //
// MDEndDiscussion.vue?d33eff98